import {Component, Input} from '@angular/core';

@Component({
    selector: 'ftl-form-group-cte',
    template: `
        <div [id]="id" class="form-group">
            <label [ngClass]="['control-label', labelClass]">
                {{ label }}
            </label>

            <div [ngClass]="['control-container', contentClass]" [click-to-edit]="id" [cte-disabled]="cteDisabled">
                <ng-content></ng-content>
            </div>
        </div>
    `
})
export class FormGroupCteComponent {

    @Input('id') id: string;
    @Input('label') label: string;
    @Input('label-class') labelClass: string = 'col-xs-12 col-sm-6';
    @Input('content-class') contentClass: string = 'col-xs-12 col-sm-6';

    @Input('cte-disabled') cteDisabled: boolean = false;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/elements/form/form-group.cte.component.ts